
import jsxElem, {render} from "jsx-no-react";

const modalContainer = document.getElementById('bmux-modal-view') || '';

const modalClose = () => {
    modalContainer.innerHTML = "";
    modalContainer.className = "";
};

const openModal = (componentName, content) => {
    const className = `bmui-modal-view-${componentName.toLowerCase()}`;
    modalContainer.className = "";
    modalContainer.classList.add(className);
    render(content, modalContainer);
};

export {
    modalContainer,
    modalClose,
    openModal
};
